import { CommonModule } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import dayjs, { Dayjs } from "dayjs";
import { TimePipe } from "libs/front-share/src/pipes/time.pipe";
import { Divider } from "../../../divider/divider.component";
import {
    CalendarEvent,
    CalendarEventMenu,
    TimelineSlot,
} from "../../calendar.types";
import { TimelineEventWrapper } from "../event-wrapper/event-wrapper.component";
import { TimelineAdapter } from "./timeline.adapter";

@Component({
    selector: "app-timeline",
    templateUrl: "./timeline.component.html",
    styleUrls: ["./timeline.component.scss"],
    standalone: true,
    imports: [CommonModule, TimelineEventWrapper, Divider, TimePipe],
})
export class Timeline extends TimelineAdapter {
    time = input.required<string>();
    days = input.required<Dayjs[]>();
    last = input.required<boolean>();
    slots = input.required<TimelineSlot[]>();

    /**
     * @description 이번 달에 해당하는 이벤트만 필터링합니다.
     */
    currentEvents = computed(() => {
        if (!this.days() || this.days()?.length === 0) return [];

        return this.events()?.filter((ev) => {
            return this.days()?.find((day) => {
                return (
                    dayjs(ev.startDate).format("YYYY-MM-DD") ===
                    day.format("YYYY-MM-DD")
                );
            });
        });
    });

    /**
     * @description 조건에따라 이벤트를 필터링합니다.
     */
    renderEvents = computed(() => {
        return this.currentEvents()?.filter((event) => {
            // const flag1 =
            //     dayjs(event.startDate).format("YYYY-MM") ===
            //     dayjs(event.endDate).format("YYYY-MM");
            const flag2 =
                dayjs(event.startDate).format("HH:00") === this.time();
            const flag3 =
                dayjs(event.endDate).diff(event.startDate, "day") === 0;
            const flag4 = !event.allDay;

            return flag2 && flag3 && flag4;
        });
    });

    menu(ev: [CalendarEventMenu, CalendarEvent]) {
        this.handleEventMenu(ev[0], ev[1]);
    }

    handleClick(day: Dayjs) {
        this.store.dayClick$.next({
            date: day.toDate(),
            events:
                this.currentEvents()?.filter((ev) => {
                    return (
                        dayjs(ev.startDate).format("YYYY-MM-DD") ===
                        day.format("YYYY-MM-DD")
                    );
                }) || [],
        });
    }
}
